import _ from 'lodash'
import axios from '@util/axios'
import store from '@store'

class ProfileService {
  constructor() {
    this.user = store.getters.user

    store.subscribe((_, state) => {
      this.user = state.auth.user
    })
  }

  async getInfo(commit = true) {
    const res = await axios({
      url: `/auth/user/`
    })

    if (commit) {
      store.commit('SET_USER', res.data.data)
    }

    return res
  }

  async update(data, commit = true) {
    const res = await axios({
      url: `/auth/user/`,
      method: 'PUT',
      data: _.pick(data, [
        'first_name',
        'last_name',
        'email',
        'phone_number',
        'is_superuser',
        'type',
        'is_active'
      ])
    })

    if (commit) {
      store.commit('SET_USER', res.data)
    }

    return res
  }

  async changePassword(data) {
    const response = await axios({
      url:
        data.uid && data.token
          ? `/auth/password/reset/confirm/`
          : `/auth/password/change/`,
      method: 'POST',
      data: _.pick(data, [
        'old_password',
        'new_password1',
        'new_password2',
        'uid',
        'token'
      ])
    })

    return response
  }

  async getDefaultReport(data, commit = true) {
    const res = await axios({
      url: `/set/default/report/${data.user_id || this.user.id}/`
    })

    if (commit) {
      store.commit('AUTH_SET_DEFAULT_REPORT', res.data.data)
    }

    return res
  }

  async setDefaultReport(data, commit = true) {
    const res = await axios({
      url: `/set/default/report/${data.user_id || this.user.id}/`,
      method: 'PUT',
      data: _.pick(data, ['default_report'])
    })

    if (commit) {
      store.commit('AUTH_SET_DEFAULT_REPORT', res.data.data)
    }

    return res
  }

  async deleteAvatar(data) {
    return await axios({
      url: `/user/profile/pic/${data.id}/`,
      method: 'DELETE'
    })
  }
}

export default new ProfileService()
